export default __webpack_public_path__ + "static/media/SourceSansPro-Italic.bfbc3f60.woff";